import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const initialState = {
  activeRoute: {},
  isAdminRoute: false
}

const getters = {
  activeRoute: state => state.activeRoute,
  isAdminRoute: state => state.activeRoute && state.activeRoute.path && state.activeRoute.path.startsWith('/administrator')
}

const mutations = {
  activeRoute: (state, activeRoute) => {
    state.activeRoute = activeRoute
  }
}

export default {
  state: initialState,
  getters,
  mutations
}
